import BaseResource from './BaseResource'

export default class Balances extends BaseResource {
  static endpoint = '/api/v1/balances' // /edge
}
